const api_endpoint = process.env.NODE_ENV === 'production' ? "https://api.cookingwright.com" : "http://localhost";
export default api_endpoint;